/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdMaterialsAttachment202,
  PostApiV1ClassroomdisciplineIdMaterialsAttachment400,
  PostApiV1ClassroomdisciplineIdMaterialsAttachment401,
  PostApiV1ClassroomdisciplineIdMaterialsAttachment404,
  PostApiV1ClassroomdisciplineIdMaterialsAttachmentMutationRequest,
  PostApiV1ClassroomdisciplineIdMaterialsAttachmentMutationResponse,
  PostApiV1ClassroomdisciplineIdMaterialsAttachmentPathParams,
} from "../../types/classPlanningMaterialController/PostApiV1ClassroomdisciplineIdMaterialsAttachment.ts";

export const postApiV1ClassroomdisciplineIdMaterialsAttachmentPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachmentPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdMaterialsAttachment202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachment202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineIdMaterialsAttachment400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachment400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdMaterialsAttachment401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachment401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdMaterialsAttachment404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachment404>;

export const postApiV1ClassroomdisciplineIdMaterialsAttachmentMutationRequestSchema =
  z.object({
    File: z.optional(z.instanceof(File)),
    CultureInfo: z.optional(z.string()),
    ParentFolderId: z.optional(z.number().int()),
    DisplayFileName: z.optional(z.string()),
    IsSlide: z.optional(z.boolean()),
    Slides: z.optional(z.number().int()),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachmentMutationRequest>;

export const postApiV1ClassroomdisciplineIdMaterialsAttachmentMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdMaterialsAttachment202Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsAttachmentMutationResponse>;
